import { gql, MutationHookOptions, useMutation } from '@apollo/client';

import { BatchBillingServiceContractsRequest } from '@work4all/models/lib/Classes/BatchBillingServiceContractsRequest.entity';
import { ApiValidationErrorType } from '@work4all/models/lib/Enums/ApiValidationErrorType.enum';

const BATCH_BILLING_SERVICE_CONTRACTS = gql`
  mutation BatchBillingServiceContracts(
    $setting: BatchBillingServiceContractsRequest!
  ) {
    batchBillingServiceContracts(setting: $setting) {
      errors {
        apiValidationErrorType
        data
        property
        validationDataType
      }
      items {
        contractCode
        invoiceCode
        message
        success
      }
    }
  }
`;

export interface BatchBillingServiceContractsMutationResponse {
  batchBillingServiceContracts: {
    errors: {
      apiValidationErrorType: ApiValidationErrorType;
      data: string;
      property: string;
      validationDataType: string;
    };
    items: {
      contractCode: number;
      invoiceCode: number;
      message: string;
      success: boolean;
    };
  };
}

export interface BatchBillingServiceContractsMutationVariables {
  setting: BatchBillingServiceContractsRequest;
}

export function useBatchBillingServiceContractsMutation(
  options?: MutationHookOptions<
    BatchBillingServiceContractsMutationResponse,
    BatchBillingServiceContractsMutationVariables
  >
) {
  return useMutation<
    BatchBillingServiceContractsMutationResponse,
    BatchBillingServiceContractsMutationVariables
  >(BATCH_BILLING_SERVICE_CONTRACTS, options);
}
